import { CSSObject } from '@emotion/react'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'

const sharedStyles = {
  borderRadius: '22px',
  transparentBlack: 'rgba(0, 0, 0, 0.2)',
  transparentWhiteBorder: '1px solid rgba(255, 255, 255, 0.2)',
}

const footerWrapper: CSSObject = {
  position: 'relative',
  top: '-77px',
  zIndex: 0,
}

const footer: CSSObject = {
  height: '77px',
  overflow: 'hidden',
  width: '375px',
}

const getFooterContent = (hasCTA: boolean): CSSObject => ({
  display: 'flex',
  height: '56px',
  justifyContent: 'flex-end',
  width: hasCTA ? '459px' : '391px',
})

const getShareReplyWrapper = (hasCTA: boolean): CSSObject => ({
  display: 'flex',
  width: hasCTA ? '323px' : '255px',
})

const getSharingWrapper = (isSmallView: boolean): CSSObject => ({
  alignItems: 'center',
  background: sharedStyles.transparentBlack,
  border: sharedStyles.transparentWhiteBorder,
  borderRadius: sharedStyles.borderRadius,
  color: '#fff',
  display: 'flex',
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.xLarge,
  height: '18px',
  justifyContent: 'center',
  margin: '22px 0 0 12px',
  padding: '11px 10px 10px 10px',
  textAlign: 'center',
  width: isSmallView ? '18px' : '213px',
})

const ctaWrapper: CSSObject = {
  bottom: '16px',
  position: 'absolute',
  width: '375px',
}

const ctaChevronWrapper: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  '.kuiper-icon': {
    paddingBottom: '11px',
  },
}

const cta: CSSObject = {
  alignItems: 'center',
  background: '#000',
  borderRadius: '20px',
  color: '#fff',
  display: 'flex',
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.medium,
  fontWeight: fontWeights.bold,
  height: '40px',
  justifyContent: 'center',
  padding: '0 26px',
}

const getReplyWrapper = (isSmallView: boolean): CSSObject => ({
  background: sharedStyles.transparentBlack,
  border: sharedStyles.transparentWhiteBorder,
  borderRadius: sharedStyles.borderRadius,
  color: '#fff',
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.xLarge,
  height: '16px',
  margin: isSmallView ? '22px 0 0 8px' : '22px 0 0 12px',
  padding: '11px 16px',
  width: isSmallView ? '153px' : '201px',
})

const iconsWrapper: CSSObject = {
  display: 'flex',
  flexDirection: 'row',
  marginTop: '22px',
  width: '136px',
}

const icons: CSSObject = {
  display: 'flex',
  flexDirection: 'row',
  listStyle: 'none',
  margin: 0,
  padding: 0,
}

const getIconPadding = (hasCTA: boolean): CSSObject => ({
  height: '40px',
  paddingRight: hasCTA ? '12px' : '8px',
})

const getShareIconPadding = (isSmallView: boolean): CSSObject => ({
  marginTop: '2px',
  paddingRight: isSmallView ? 0 : '9px',
})

const styles = {
  cta,
  ctaChevronWrapper,
  ctaWrapper,
  footer,
  footerWrapper,
  getFooterContent,
  getIconPadding,
  getReplyWrapper,
  getShareIconPadding,
  getShareReplyWrapper,
  getSharingWrapper,
  icons,
  iconsWrapper,
}

export { styles }
